__turbopack_context__.v({
  "container": "Expandable-module__mOuaKG__container",
  "content": "Expandable-module__mOuaKG__content",
  "open": "Expandable-module__mOuaKG__open",
});
